import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AutenticacionService } from 'src/app/services/autenticacion.service';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { MenuService } from '../../services/menu.service';


@Component({
  selector: 'dashboard_expedientes',
  templateUrl: './dashboard_expedientes.component.html',
  styleUrls: ['./dashboard_expedientes.component.scss']
})
export class DashboardExpedientesComponent implements OnInit{

  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public autenticacionService: AutenticacionService,
    public menuService: MenuService) {}

  ngOnInit() {
    
  }
}
